import React from 'react'
import { css } from '@emotion/css'
import { FormattedMessage } from 'react-intl'
import { WithTooltip } from '../../design-system'
import { theme as deprecatedTheme } from '../../styled'
import { theme } from '@contrast-security-inc/design-system-foundations'

export interface ItemWithOverflowProps {
  readonly items: string[]
  readonly labelId?: string
  readonly defaultId?: string
}

const containerClassName = css`
  display: inline-flex;
  margin-top: 3px;
  flex-direction: row;
  font-size: 12px;
  color: ${theme.color.neutral60};
  font-family: ${deprecatedTheme.fontFamilies.secondary};
`

const labelClassName = css`
  font-weight: ${deprecatedTheme.fontWeights.primary.bold};
  flex-basis: 4em;
  white-space: nowrap;
`

const itemClassName = css`
  padding-left: 0.5em;
  flex-basis: 30em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

const tooltipChildrenClassName = css`
  color: ${theme.color.teal50};
  cursor: pointer;
  margin-left: 0.5em;
  width: max-content;
`

export const MetadataItemWithOverflow = ({
  items,
  labelId,
  defaultId
}: ItemWithOverflowProps) => (
  <div className={containerClassName}>
    {labelId && (
      <FormattedMessage id={labelId}>
        {(label) => <div className={labelClassName}>{`${label}: `}</div>}
      </FormattedMessage>
    )}
    {items.length === 0 && defaultId && (
      <FormattedMessage id={defaultId}>
        {(defaultMessage) => (
          <div className={itemClassName}>{defaultMessage}</div>
        )}
      </FormattedMessage>
    )}
    {items[0] && <div className={itemClassName}>{items[0]}</div>}
    {items.length > 1 && (
      <FormattedMessage id="detail_more">
        {(moreMessage) => (
          <WithTooltip
            children={() => (
              <div className={tooltipChildrenClassName}>{`+${
                items.length - 1
              } ${moreMessage}`}</div>
            )}
            renderTooltipContent={() =>
              items
                .slice(1, items.length)
                .map((item, index) => <div key={index}>{item}</div>)
            }
            placement="bottom"
          />
        )}
      </FormattedMessage>
    )}
  </div>
)
